// services/cache/denominacoesGenericasMemoryCache.ts
import { useEffect, useState } from 'react';

import { TypeDenominacaoGenerica } from '../../pages/daf/ProdutosDAF/Produtos/types';
import { getAllDenominacoesGenericas } from '../produtosDAF/denominacoesGenericasService';

let denominacoesGenericasCache: TypeDenominacaoGenerica[] | null = null;

export function getDenominacoesGenericasMemoryCache() {
  return denominacoesGenericasCache;
}

export function setDenominacoesGenericasMemoryCache(
  data: TypeDenominacaoGenerica[],
) {
  denominacoesGenericasCache = data;
}

export function clearDenominacoesGenericasMemoryCache() {
  denominacoesGenericasCache = null;
}

export function useDenominacoesGenericasCache() {
  const [data, setData] = useState<TypeDenominacaoGenerica[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cached = getDenominacoesGenericasMemoryCache();
    if (cached) {
      setData(cached);
      return;
    }

    setLoading(true);
    getAllDenominacoesGenericas()
      .then((result) => {
        setData(result);
        setDenominacoesGenericasMemoryCache(result);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}
